export default __webpack_public_path__ + "94b2ba4f94db40f1c0bcaf297237a0bc.jpg";